import state from "./state.js";
const getters = {
  locations(state) {
    return state.locations;
  },
  zones(state) {
    return state.zones;
  },
  modems(state) {
    return state.modems;
  },
  userDetails(state) {
    return state.userInfo;
  }
};

export default getters;
